module.exports = __webpack_public_path__ + "img/male.cbc1b4bd.png";